module.exports = __webpack_public_path__ + "static/img/3.a93b686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R404A/3.jpg
// module id = KVMq
// module chunks = 1